import { educators } from "@/data/educators";

const teamSummaries: Record<string, { role: string; description: string }> = {
  "Todd Larsen": {
    role: "Co-founder · Engineering & AI implementation",
    description:
      "Former Global Platform Engineer at Groupon and Founding Engineer at Digit. Brings product, engineering, and technical leadership experience to practical AI adoption.",
  },
  "Stephen Bates": {
    role: "Co-founder · Leadership & organizational change",
    description:
      "Executive coach and leadership consultant with more than 25 years of experience in corporate training and developing technical leaders.",
  },
  "John Chapman": {
    role: "Coaching & team development",
    description:
      "Former IT Applications Services & Development Manager at iPSL. Helps leaders and teams build confidence and turn learning into action.",
  },
  "Amelia Leigner": {
    role: "Product, marketing & growth",
    description:
      "Fractional CMO for Tech Leaders and product and growth leader at Bottega8, with experience helping startups and AI companies launch and scale.",
  },
  "Nick Talwar": {
    role: "AI strategy & technical leadership",
    description:
      "Former Microsoft technical leader and CTO and Partner at Bottega8. Advises executives and boards on AI strategy and implementation.",
  },
  "Matt Kirk": {
    role: "AI & machine learning",
    description:
      "Engineering leader with experience at AugmentAI and Zeitworks, and author of the O’Reilly book Thoughtful Machine Learning.",
  },
  "Manju Abraham": {
    role: "Enterprise engineering & transformation",
    description:
      "VP of Engineering at Bottega8 and former engineering executive at HPE and Delphix. Connects AI ambition with people, governance, and organizational change.",
  },
};

// Keep names, photos, and ordering aligned with the full educator profiles.
export const TEAM_PROFILES = educators.map((person) => {
  const summary = teamSummaries[person.name] ?? {
    role: person.role,
    description: person.bio[0],
  };

  return {
    name: person.name,
    image: person.image,
    role: summary.role,
    description: summary.description,
  };
});
